module.exports = __webpack_public_path__ + "img/flow.5f5b2680.jpg";